module.exports = __webpack_public_path__ + "img/02.a399f85e.png";